// extracted by mini-css-extract-plugin
export default {"addUser":"AddUser_addUser__A9AJ7","error":"AddUser_error__HRiAb"};